import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Seo } from "@/components/Seo";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Servizi from "@/pages/Servizi";
import Valutazione from "@/pages/Valutazione";
import Media from "@/pages/Media";
import Contatti from "@/pages/Contatti";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";

const SEO = {
  "/": {
    title: "Professor Carlo Enrico Traverso | Oculista a Genova e Savona",
    description:
      "Professor Carlo Enrico Traverso, oculista e chirurgo oftalmico a Genova e Savona. Attività clinica e chirurgica per cataratta, glaucoma, cornea e chirurgia refrattiva.",
    canonical: "https://professortraverso.it/",
  },
  "/chi-sono": {
    title: "Professor Carlo Enrico Traverso | Oculista e Chirurgo Oftalmico",
    description:
      "Carriera, formazione e attività professionale del Professor Carlo Enrico Traverso, oculista e chirurgo oftalmico con attività a Genova e Savona.",
    canonical: "https://professortraverso.it/chi-sono",
  },
  "/di-cosa-mi-occupo": {
    title: "Cataratta, Glaucoma e Chirurgia Refrattiva | Professor Traverso",
    description:
      "Attività del Professor Carlo Enrico Traverso in chirurgia della cataratta, glaucoma, cornea, chirurgia refrattiva e oftalmologia del segmento anteriore.",
    canonical: "https://professortraverso.it/di-cosa-mi-occupo",
  },
  "/richiedi-una-valutazione": {
    title: "Richiedi una valutazione | Professor Carlo Enrico Traverso",
    description:
      "Richiedi una valutazione con il Professor Carlo Enrico Traverso per visita oculistica o attività chirurgica a Genova e Savona.",
    canonical: "https://professortraverso.it/richiedi-una-valutazione",
  },
  "/media": {
    title: "Media e Interviste | Professor Carlo Enrico Traverso",
    description:
      "Video, interviste e approfondimenti del Professor Carlo Enrico Traverso su glaucoma, cataratta, prevenzione, chirurgia e salute della vista.",
    canonical: "https://professortraverso.it/media",
  },
  "/contatti": {
    title: "Contatti | Oculista a Genova e Savona | Professor Traverso",
    description:
      "Contatti e sedi del Professor Carlo Enrico Traverso per visite oculistiche e attività chirurgica a Genova e Savona.",
    canonical: "https://professortraverso.it/contatti",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Professor Carlo Enrico Traverso",
    canonical: "https://professortraverso.it/privacy-policy",
    robots: "noindex,follow",
  },
  "/cookie-policy": {
    title: "Cookie Policy | Professor Carlo Enrico Traverso",
    canonical: "https://professortraverso.it/cookie-policy",
    robots: "noindex,follow",
  },
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SeoManager = () => {
  const { pathname } = useLocation();
  return <Seo {...(SEO[pathname] || SEO["/"])} />;
};

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <SeoManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-sono" element={<ChiSono />} />
            <Route path="/di-cosa-mi-occupo" element={<Servizi />} />
            <Route path="/richiedi-una-valutazione" element={<Valutazione />} />
            <Route path="/media" element={<Media />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
